import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '@app-services/user/user.service';

@Component({
  selector: 'app-intersetedcourses',
  templateUrl: './intersetedcourses.component.html',
  styleUrls: ['./intersetedcourses.component.css']
})
export class IntersetedcoursesComponent implements OnInit {
  public modes :any = [
    {
      mode :'Online',
      checked:false
    },
    {
      mode :'Offline',
      checked:true
    },
  ]
public selectedModes:any =[]
  constructor(private dialogRef: MatDialogRef<IntersetedcoursesComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
      console.log('this.data: ', this.data);
     }

  ngOnInit(): void {
    this.selectedModes = this.modes?.filter(v=>v.checked)?.map(v=>v.mode)
  }
  submitIntersetedCourse(){
    var  user_details_from_server  = localStorage.getItem('user_details_from_server') ? JSON.parse(localStorage.getItem('user_details_from_server')) :{};
    var examId = user_details_from_server?.exams.find(v=>v?.name?.replace(' ','')?.toUpperCase() == localStorage.getItem('targetExamName'))
    console.log('this.modes: ', this.modes);
    var modeselected = this.modes?.filter(v=>v.checked)?.map(v=>v.mode)
    let body = {
      "courseMode": modeselected?.length == 2 ? 'both': modeselected?.toString(),
      "examId": examId?.examId||0,
      "examtype": this.data?.examtype,
      "hallTicket": "",
      "schoolName": ""
    }
    this.userService.addUserAsset(body,user_details_from_server?.userId).subscribe((resp)=>{
      let lsq_details = JSON.parse(localStorage.getItem('score-tracking-data')) || {};
      lsq_details['score_interest_in_online_or_offline_courses'] = body?.courseMode + ' courses';
      localStorage.setItem('score-tracking-data', JSON.stringify(lsq_details))
      this.dialogRef.close()
    },()=>{
      this.dialogRef.close()
    })
  }
  checkboxInitalise(mode){
mode.checked = !mode.checked;
this.selectedModes = this.modes?.filter(v=>v.checked)?.map(v=>v.mode)
  }
}
